import {connect} from 'react-redux'
import FeedbackTable from './FeedbackTable'
import FeedbackDetail from './FeedbackDetail'
import {
  feedbackPageRequest,
  onClickRow,
  submitReplyRequest
} from 'actions/customers/feedback'
import styles from './style.feedback.css'
import ActionBar from './ActionBar'
import {browserHistory} from 'react-router'

class Feedback extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(feedbackPageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  constructor () {
    super()
    this.state = {
      feedbackId: 0,
      feedbackType: '',
      feedbackMode: ''
    }
  }

  render () {
    let {feedbackMessages, transactionDetail} = this.props.data.customers.feedback

    return (
      <div id='feedback-list' className={styles.feedback}>
        <div className={styles['mk-action-bar']}>
          <div className='row'>
            <ActionBar />
          </div>
        </div>
        <div className='mk-customer-feedback moka-container-content'>
          <FeedbackTable onClickRow={this._onClickRow} />
          <FeedbackDetail
            feedbackMessages={feedbackMessages}
            onSubmitReply={this._handleSubmit}
            transactionDetail={transactionDetail}
            feedbackType={this.state.feedbackType}
            feedbackMode={this.state.feedbackMode}
          />
        </div>
      </div>
    )
  }

  _onClickRow = (feedback) => {
    $('#customer-feedback').hide()
    $('#customer-feedback-detail').show()
    this.props.dispatch(onClickRow(feedback))
    this.setState({feedbackId: feedback.id})
    this.setState({feedbackType: feedback.feedback_type})
    this.setState({feedbackMode: feedback.mode})
  }

  _handleSubmit = (feedbackData) => {
    let {comment, feedbackfrom, business_name} = feedbackData
    let id = this.state.feedbackId
    let commentSanited = ''
    if (feedbackfrom === 'sms') {
      commentSanited = comment.substring(business_name.length)
    } else {
      commentSanited = comment
    }
    feedbackData = {
      comment: commentSanited,
      feedback_id: id,
      feedback_from: feedbackfrom
    }
    this.props.dispatch(submitReplyRequest(feedbackData))
  }
}

function mapStateToProps (state) {
  return {
    data: {
      customers: {
        feedback: state.customers.feedback
      },
      form: state.form,
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(mapStateToProps)(Feedback)



// WEBPACK FOOTER //
// ./app/pages/Customers/Feedback/Feedback.js